module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av317-e5c71933b1778364201020caeeaf4c18.jpg";